module.exports = __webpack_public_path__ + "img/tgb2.d2da1968.jpeg";